/**
 * part 模块英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 */
export default {
  '请输入区域名称': 'Please enter area name',
  '请输入备注': 'Please enter remark',
  '间隔累计正流量和间隔累计逆流量(八字节)': 'Interval Cumulative Forward and Reverse Flow (8 Bytes)',
  '间隔累计正流量和间隔累计逆流量(四字节)': 'Interval Cumulative Forward and Reverse Flow (4 Bytes)',
  '间隔累计流量(两字节)': 'Interval Cumulative Flow (2 Bytes)',
  '间隔累计流量(四字节)': 'Interval Cumulative Flow (4 Bytes)',
  ',日结数据指示: ': ', daily settlement data format: ',
  ',时间间隔: ': ', time interval: ',
  ',端口号:': ', port:',
  ',结束时间:': ', end time:',
  ',错峰间隔: ': ', off-peak interval: ',
  ',高频上报次数: ': ', high-frequency report count: ',
  '15位IMEI': '15-digit IMEI',
  'APN': 'APN',
  'AT指令校时': 'AT Command Time Sync',
  'IMSI号': 'IMSI No.',
  'IP地址': 'IP Address',
  'IP地址: ': 'IP address: ',
  'NB加密使能': 'NB Encryption Enabled',
  'SIM卡号': 'SIM Card No.',
  'V,告警阈值2:': 'V, alarm threshold 2:',
  '上报明细': 'Report Detail',
  '上电上报': 'Power-on Report',
  '不使能': 'Disabled',
  '不启用': 'Disabled',
  '不执行': 'Not Executed',
  '不支持': 'Not Supported',
  '两字节': '2 Bytes',
  '产品型号': 'Product Model',
  '低电压故障': 'Low Voltage Fault',
  '你确定要撤销该条记录吗?': 'Are you sure you want to revoke this record?',
  '使能': 'Enabled',
  '信号强度': 'Signal Strength',
  '信噪比': 'Signal-to-Noise Ratio',
  '信息': 'Notice',
  '修改根秘钥': 'Modify Root Key',
  '修改运行密匙': 'Modify Operating Key',
  '修改运行秘钥': 'Modify Operating Key',
  '元': 'CNY',
  '充值次数': 'Recharge Count',
  '八字节(包含正向流量和逆向流量)': '8 Bytes (forward and reverse flow)',
  '共{total}条': 'Total {total} records',
  '关闭': 'Close',
  '关阀': 'Close Valve',
  '其他': 'Other',
  '内部温度(℃)': 'Internal Temperature (℃)',
  '写表号': 'Write Meter No.',
  '分': 'min',
  '分钟': 'min',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '到达失联次数关阀': 'Lost-Contact Count Close Valve',
  '到达报警量关阀': 'Alarm Amount Close Valve',
  '刷卡开阀': 'Card Swipe Open Valve',
  '刷新': 'Refresh',
  '剩余金额更新': 'Remaining Balance Update',
  '单价(元)': 'Unit Price (CNY)',
  '即时告警ID': 'Instant Alarm ID',
  '历史日结信息查询': 'Daily Settlement History Query',
  '压力报警上限': 'Pressure Alarm Upper Limit',
  '压力报警上限(MPa)': 'Pressure Alarm Upper Limit (MPa)',
  '压力报警下限': 'Pressure Alarm Lower Limit',
  '压力报警下限(MPa)': 'Pressure Alarm Lower Limit (MPa)',
  '压力报警灵敏度': 'Pressure Alarm Sensitivity',
  '压力数据指示': 'Pressure Data Format',
  '压力采样起始时间': 'Pressure Sampling Start Time',
  '压力采集时间间隔': 'Pressure Sampling Interval',
  '压力采集组数': 'Pressure Sampling Groups',
  '压力采集起始时间': 'Pressure Sampling Start Time',
  '反流告警阈值': 'Reverse Flow Alarm Threshold',
  '反流告警阈值(L/h)': 'Reverse Flow Alarm Threshold (L/h)',
  '发送时间': 'Send Time',
  '发送状态': 'Send Status',
  '取消': 'Cancel',
  '取消强制': 'Cancel Force',
  '取消强制关阀': 'Cancel Forced Close Valve',
  '取消选择': 'Deselect',
  '取消阀控': 'Cancel Valve Control',
  '否': 'No',
  '启用': 'Enabled',
  '告警阈值1: ': 'Alarm threshold 1: ',
  '周': 'Week',
  '命令ID': 'Command ID',
  '命令任务列表': 'Command Task List',
  '命令内容': 'Command Content',
  '命令参数': 'Command Parameters',
  '命令回应内容': 'Command Response',
  '命令标识': 'Command ID',
  '命令类型': 'Command Type',
  '命令结果': 'Command Result',
  '命令详情列表': 'Command Detail List',
  '命令队列': 'Command Queue',
  '四字节': '4 Bytes',
  '四字节(包含正向流量和逆向流量)': '4 Bytes (forward and reverse flow)',
  '回应时间': 'Response Time',
  '处理失败': 'Processing Failed',
  '处理成功': 'Processed Successfully',
  '备注': 'Remark',
  '大口径表': 'Large-caliber Meter',
  '天': 'Day',
  '存储器故障': 'Memory Fault',
  '定时上报': 'Scheduled Report',
  '定时上报信息': 'Scheduled Report Info',
  '定时上报离散估长(秒)': 'Scheduled Report Spread Duration (s)',
  '定时上报离散结束时间': 'Scheduled Report Spread End Time',
  '定时上报离散起始时间': 'Scheduled Report Spread Start Time',
  '定时上报频率': 'Scheduled Report Frequency',
  '密集采样信息': 'Intensive Sampling Info',
  '密集采样天数': 'Intensive Sampling Days',
  '密集采样数据格式': 'Intensive Sampling Data Format',
  '密集采样时间间隔(分钟)': 'Intensive Sampling Interval (min)',
  '密集采样结束时间': 'Intensive Sampling End Time',
  '密集采样起始时间': 'Intensive Sampling Start Time',
  '密集采集流量': 'Intensive Sampled Flow',
  '导出': 'Export',
  '导出文件': 'Export File',
  '小区ID': 'Cell ID',
  '小口径表': 'Small-caliber Meter',
  '展开': 'Expand',
  '工作模式': 'Work Mode',
  '已下达': 'Issued',
  '已取消': 'Cancelled',
  '已选择 {count} 项': '{count} items selected',
  '干扰不关阀': 'No Valve Close on Interference',
  '干扰关阀': 'Interference Close Valve',
  '干扰关阀时间(分钟)': 'Interference Close Valve Time (min)',
  '干扰持续时间(分钟)': 'Interference Duration (min)',
  '平台计费水表': 'Platform-billed Water Meter',
  '年': 'Year',
  '开始时间': 'Start Time',
  '开阀': 'Open Valve',
  '强制关阀': 'Force Close Valve',
  '强制开阀': 'Force Open Valve',
  '当前剩余金额(元)': 'Current Remaining Balance (CNY)',
  '当前累计用量(m³)': 'Current Cumulative Usage (m³)',
  '当前选择：': 'Currently selected:',
  '手动上报': 'Manual Report',
  '执行失败': 'Execution Failed',
  '执行成功': 'Executed Successfully',
  '批量操作': 'Batch Operations',
  '折叠': 'Collapse',
  '报警不关阀、透支不关阀': 'Do not close valve on alarm or overdraft',
  '报警不关阀、透支关阀': 'Close valve on overdraft only',
  '报警关阀、透支不关阀': 'Close valve on alarm, not on overdraft',
  '报警关阀、透支关阀': 'Close valve on alarm and overdraft',
  '报警金额': 'Alarm Amount',
  '报警金额(元)': 'Alarm Amount (CNY)',
  '持续反流告警时间(分钟)': 'Reverse Flow Alarm Duration (min)',
  '持续反流时间': 'Reverse Flow Duration',
  '持续过流告警时间': 'Overcurrent Alarm Duration',
  '持续过流告警时间(分钟)': 'Overcurrent Alarm Duration (min)',
  '指令标记帧': 'Command Mark Frame',
  '按键开阀使能': 'Open Valve Button Enabled',
  '接收内容': 'Received Content',
  '接收回应时间': 'Response Received At',
  '描述': 'Description',
  '提示': 'Notice',
  '操作': 'Action',
  '收起': 'Collapse',
  '故障': 'Fault',
  '故障上报': 'Fault Report',
  '故障产生时间': 'Fault Occurrence Time',
  '故障持续时间': 'Fault Duration',
  '故障类型': 'Fault Type',
  '数据清除': 'Data Clear',
  '新增': 'Add',
  '无': 'None',
  '无到位信号': 'No In-place Signal',
  '无动作': 'No Action',
  '无记录': 'No Record',
  '无阀': 'No Valve',
  '日': 'Day',
  '日最高流量': 'Daily Max Flow',
  '日最高流量时间': 'Daily Max Flow Time',
  '日用量两字节': 'Daily Usage (2 bytes)',
  '日用量四字节': 'Daily Usage (4 bytes)',
  '日结数据组数: ': 'Daily settlement data groups: ',
  '日结累计正流量和日结累计负流量两字节': 'Daily Settlement Forward & Reverse Total Flow (2 bytes)',
  '日结累计正流量和日结累计负流量四字节': 'Daily Settlement Forward & Reverse Total Flow (4 bytes)',
  '日结累计流量两字节': 'Daily Settlement Total Flow (2 bytes)',
  '日结累计流量四字节': 'Daily Settlement Total Flow (4 bytes)',
  '日结累计流量格式': 'Daily Settlement Flow Format',
  '日结累计流量组数': 'Daily Settlement Flow Groups',
  '时': 'h',
  '是': 'Yes',
  '暖通阀': 'HVAC Valve',
  '更多': 'More',
  '最大失联次数阈值': 'Max Lost-Contact Count Threshold',
  '最大激活上报次数': 'Max Activation Report Count',
  '月': 'Month',
  '有': 'Yes',
  '服务器地址': 'Server Address',
  '未发送': 'Not Sent',
  '未知': 'Unknown',
  '机电分离故障': 'Mechanical-Electrical Separation Fault',
  '查询': 'Query',
  '查询基础信息': 'Query Basic Info',
  '查询实时数据': 'Query Real-time Data',
  '查询终端参数': 'Query Terminal Parameters',
  '查询结束时间': 'End time',
  '查询起始时间': 'Start time',
  '查询起止时间': 'Query Time Range',
  '校时': 'Time Sync',
  '校时方式': 'Time Sync Mode',
  '模块初始化配置': 'Module Initialization Config',
  '模组号': 'Module No.',
  '模组号 ': 'Module No. ',
  '模组版本号': 'Module Version',
  '次': 'times',
  '正在下发': 'Dispatching',
  '正常': 'Normal',
  '水表表号': 'Water Meter No.',
  '消息有误': 'Invalid Message',
  '清空': 'Clear',
  '清除外接EEPROM内的数据': 'Clear External EEPROM Data',
  '清除故障': 'Clear Fault',
  '清除表端故障': 'Clear Meter Faults',
  '清除表端数据': 'Clear Meter Data',
  '温度报警上限': 'Temperature Alarm Upper Limit',
  '温度报警上限(℃)': 'Temperature Alarm Upper Limit (℃)',
  '温度报警下限': 'Temperature Alarm Lower Limit',
  '温度报警下限(℃)': 'Temperature Alarm Lower Limit (℃)',
  '温度报警灵敏度': 'Temperature Alarm Sensitivity',
  '温度数据指示': 'Temperature Data Format',
  '温度采样时间间隔': 'Temperature Sampling Interval',
  '温度采样组数': 'Temperature Sampling Groups',
  '温度采样起始时间': 'Temperature Sampling Start Time',
  '温度采集时间间隔': 'Temperature Sampling Interval',
  '温度采集组数': 'Temperature Sampling Groups',
  '温度采集起始时间': 'Temperature Sampling Start Time',
  '状态': 'Status',
  '状态字信息': 'Status Word Info',
  '用户地址': 'Customer Address',
  '用户姓名': 'Customer Name',
  '用户手机号': 'Customer Mobile Phone',
  '用户模式': 'User Mode',
  '用户编号': 'Customer No.',
  '电信AEP': 'China Telecom AEP',
  '电信OC': 'China Telecom OC',
  '电压告警阈值': 'Voltage Alarm Threshold',
  '电压告警阈值1(V)': 'Voltage Alarm Threshold 1 (V)',
  '电压告警阈值2(V)': 'Voltage Alarm Threshold 2 (V)',
  '电池电压(mv)': 'Battery Voltage (mV)',
  '直通用水': 'Direct Water Use',
  '确定': 'OK',
  '确定删除吗?': 'Are you sure you want to delete?',
  '磁干扰故障': 'Magnetic Interference Fault',
  '秒': 's',
  '移动': 'China Mobile',
  '程序序列号': 'Program Serial No.',
  '端口号': 'Port',
  '累计发送失败次数': 'Total Failed Sends',
  '累计发送成功次数': 'Total Successful Sends',
  '累计用量超限关阀': 'Cumulative Usage Limit Close Valve',
  '累计通讯耗时(s)': 'Total Communication Time (s)',
  '红外加密使能': 'Infrared Encryption Enabled',
  '终端参数设置': 'Terminal Parameter Settings',
  '终端故障记录': 'Terminal Fault Records',
  '终端时钟': 'Terminal Clock',
  '终端软件版本': 'Terminal Software Version',
  '终端运行时间': 'Terminal Running Time',
  '编辑': 'Edit',
  '缺电不关阀': 'No Valve Close on Low Power',
  '缺电关阀': 'Low Power Close Valve',
  '缺电关阀时间(分钟)': 'Low-Power Close Valve Time (min)',
  '联网失败原因': 'Network Failure Reason',
  '联网失败时间': 'Network Failure Time',
  '联网失败记录': 'Network Failure Records',
  '联通': 'China Unicom',
  '脉冲系数': 'Pulse Factor',
  '自动关阀/阀门自检': 'Auto Close Valve / Valve Self-check',
  '自动开阀/ 阀门自检': 'Auto Open Valve / Valve Self-check',
  '自动校时': 'Automatic Time Sync',
  '自定义列': 'Custom Columns',
  '自定义校时': 'Custom Time Sync',
  '表号': 'Meter No.',
  '表底数': 'Meter Base',
  '表底数(L)': 'Meter Base (L)',
  '表端不计费': 'No Meter-side Billing',
  '表端自检功能': 'Meter Self-Check',
  '表端计费': 'Meter-side Billing',
  '表端计费模式': 'Meter-side Billing Mode',
  '表端计费水量表': 'Meter-billed Volume Meter',
  '表类型': 'Meter Type',
  '表类型MN100-2D的撤销操作是针对单个设备的，点击撤销会撤销该设备的全部未执行的命令。': 'The revoke operation for meter type MN100-2D targets a single device. Revoking will revoke all unexecuted commands of this device.',
  '表编号': 'Meter No.',
  '覆盖等级': 'Coverage Level',
  '记录值': 'Record Value',
  '记录条数': 'Record Count',
  '设备ID': 'Device ID',
  '试用量': 'Trial Quantity',
  '详情': 'Details',
  '请输入15位IMEI代表表ID': 'Enter 15-digit IMEI as meter ID',
  '请输入15位模组号 ': 'Enter 15-digit module no. ',
  '请输入上报明细': 'Enter report detail',
  '请输入信号强度': 'Enter signal strength',
  '请输入信噪比': 'Enter signal-to-noise ratio',
  '请输入命令内容': 'Enter command content',
  '请输入命令参数': 'Enter command parameters',
  '请输入接收内容': 'Enter received content',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户编号': 'Please enter customer No.',
  '请输入表类型': 'Enter meter type',
  '请输入表编号': 'Please enter meter No.',
  '请输入设备ID': 'Please enter device ID',
  '请选择命令标识': 'Please select command ID',
  '请选择运营商': 'Select carrier',
  '请选择通讯状态': 'Please select communication status',
  '读SIM卡ismi号': 'Read SIM IMSI No.',
  '读卡上报': 'Card Read Report',
  '读取SIM卡号': 'Read SIM Card No.',
  '读取最近10次联网失败原因': 'Read Last 10 Network Failure Reasons',
  '读取最近10次表端故障原因': 'Read Last 10 Meter Fault Reasons',
  '读取最近10次阀门动作原因': 'Read Last 10 Valve Action Reasons',
  '读取模组IMEI号': 'Read Module IMEI',
  '读取模组版本号': 'Read Module Version',
  '读取模组状态': 'Read Module Status',
  '读取程序版本信息': 'Read Program Version Info',
  '读取表上报参数': 'Read Meter Report Parameters',
  '读取表具信息': 'Read Meter Info',
  '读取表历史数据': 'Read Meter History Data',
  '读取表工作参数': 'Read Meter Working Parameters',
  '读取表端最近10次磁干扰故障': 'Read Last 10 Magnetic Interference Faults',
  '读取表网络参数': 'Read Meter Network Parameters',
  '读表号': 'Read Meter No.',
  '调试模式': 'Debug Mode',
  '起始时间: ': 'Start time: ',
  '起始条数': 'Start Record No.',
  '超声波水表': 'Ultrasonic Water Meter',
  '过期未执行': 'Expired, Not Executed',
  '过流告警': 'Overcurrent Alarm',
  '过流告警关阀': 'Overcurrent Alarm Close Valve',
  '过流告警阈值': 'Overcurrent Alarm Threshold',
  '过流告警阈值(L/h)': 'Overcurrent Alarm Threshold (L/h)',
  '运营商': 'Carrier',
  '运营商平台校时': 'Carrier Platform Time Sync',
  '远程关阀、阀门卡关阀': 'Remote/Card Close Valve',
  '远程开阀、阀门卡开阀': 'Remote/Card Open Valve',
  '远程强制关阀': 'Remote Forced Close Valve',
  '逆流告警': 'Reverse Flow Alarm',
  '透支关阀': 'Overdraft Close Valve',
  '透支金额': 'Overdraft Amount',
  '透支金额(元)': 'Overdraft Amount (CNY)',
  '通讯状态': 'Communication Status',
  '配置表上报参数': 'Configure Meter Report Parameters',
  '配置表工作参数': 'Configure Meter Working Parameters',
  '配置表网络参数': 'Configure Meter Network Parameters',
  '采样间隔正流量和逆流量': 'Sampling Interval Forward and Reverse Flow',
  '重传次数': 'Retransmission Count',
  '重传间隔': 'Retransmission Interval',
  '重传间隔(秒)': 'Retransmission Interval (s)',
  '重置': 'Reset',
  '间隔流量数据格式': 'Interval Flow Data Format',
  '间隔流量时间间隔(分钟)': 'Interval Flow Interval (min)',
  '间隔累计正流量和间隔累计逆流量': 'Interval Cumulative Forward and Reverse Flow',
  '间隔累计流量': 'Interval Cumulative Flow',
  '阀控操作': 'Valve Control Operation',
  '阀门关故障': 'Valve Close Fault',
  '阀门关闭': 'Valve Closed',
  '阀门关闭(强制)': 'Valve Closed (Forced)',
  '阀门到位超时时间': 'Valve Position Timeout',
  '阀门到位超时时间(秒)': 'Valve Position Timeout (s)',
  '阀门动作上报': 'Valve Action Report',
  '阀门动作原因': 'Valve Action Reason',
  '阀门动作时间': 'Valve Action Time',
  '阀门动作状态': 'Valve Action Status',
  '阀门动作记录查询': 'Valve Action Record Query',
  '阀门堵转功能不启用': 'Valve Stall Function Disabled',
  '阀门堵转功能启用': 'Valve Stall Function Enabled',
  '阀门开关指令': 'Valve On/Off Command',
  '阀门开关配置': 'Valve On/Off Config',
  '阀门开启': 'Valve Open',
  '阀门开启(强制)': 'Valve Open (Forced)',
  '阀门开故障': 'Valve Open Fault',
  '阀门维护': 'Valve Maintenance',
  '阀门维护功能': 'Valve Maintenance Function',
  '阀门配置': 'Valve Configuration',
  '阀门锈死故障': 'Rusted Valve Fault',
  '阶梯计费水表': 'Tiered-billed Water Meter',
  '预付费阀控功能': 'Prepaid Valve Control',
  '高瞬时流量': 'High Instantaneous Flow',
  '高频上报': 'High-frequency Report',
  '高频上报功能': 'High-frequency Reporting Function',
  '高频上报周期: ': 'High-frequency Report Interval: ',
  '间隔流量时间间隔': 'Interval Flow Time Interval',
}
